import { orgScopedApiClient } from 'api/orgScopedClient'
import { Alert, AlertSubscription, TriggeredAlert } from 'types'

import { CerebroPaginatedResponse, CerebroResourceResponse } from '../types'

// Alert Configurations
export const getAlert = (
    alertId: string
): Promise<CerebroResourceResponse<Alert>> =>
    orgScopedApiClient.get(`/api/alert_configuration/${alertId}/`)

export const updateAlert = (
    alertId: string,
    data: unknown
): Promise<CerebroResourceResponse<Alert>> =>
    orgScopedApiClient.patch(`/api/alert_configuration/${alertId}/`, data)

export const deleteAlert = (
    alertId: string
): Promise<CerebroResourceResponse<Alert>> =>
    orgScopedApiClient.delete(`/api/alert_configuration/${alertId}/`)

export const getAlerts = (): Promise<CerebroPaginatedResponse<Alert>> =>
    orgScopedApiClient.get('/api/alert_configurations/')

export const createAlert = (
    data: unknown
): Promise<CerebroResourceResponse<Alert>> =>
    orgScopedApiClient.post('/api/alert_configurations/', data)

// Alert Subscriptions
export const createAlertSubscription = (
    data: unknown
): Promise<CerebroResourceResponse<AlertSubscription>> =>
    orgScopedApiClient.post('/api/alert_subscriptions/', data)

export const deleteAlertSubscription = (
    id: string
): Promise<CerebroResourceResponse<AlertSubscription>> =>
    orgScopedApiClient.delete(`/api/alert_subscription/${id}/`)

export const getAlertSubscriptions = (
    params: unknown
): Promise<CerebroPaginatedResponse<AlertSubscription>> =>
    orgScopedApiClient.get('/api/alert_subscriptions/', { params })

// Triggered Alerts
export const getTriggeredAlert = (
    alertId: string
): Promise<CerebroResourceResponse<TriggeredAlert>> =>
    orgScopedApiClient.get(`/api/triggered_alert/${alertId}/`)

export const getTriggeredAlerts = (
    params: unknown
): Promise<CerebroPaginatedResponse<TriggeredAlert>> =>
    orgScopedApiClient.get('/api/triggered_alerts/', { params })

export const updateTriggeredAlert = (
    alertId: string,
    data: unknown
): Promise<CerebroResourceResponse<TriggeredAlert>> =>
    orgScopedApiClient.patch(`/api/triggered_alert/${alertId}/`, data)
